
    <app-delete
      [form]="form$ | async"
      [formErrors]="formErrors$ | async"
      (doAccountDelete)="doAccountDelete($event)"
    ></app-delete>
  